import { getContext, setContext } from "svelte";
import type { DeviceInformationStore } from "./types";

const DEVICE_INFORMATION_CONTEXT_KEY = Symbol("device-information");

export function setDeviceInformationContext(store: DeviceInformationStore) {
	setContext(DEVICE_INFORMATION_CONTEXT_KEY, store);
}

export function getDeviceInformationContext(): DeviceInformationStore {
	const context = getContext<DeviceInformationStore>(
		DEVICE_INFORMATION_CONTEXT_KEY,
	);
	if (!context) {
		throw new Error(
			"DeviceInformationContext must be used within a DeviceInformationProvider",
		);
	}
	return context;
}
